<button
  [ngClass]="{ hidden: (facetList$ | async)?.facets.length === 0 }"
  #trigger
  class="btn btn-action btn-block dialog-trigger"
  (click)="launch()"
  >
  <cx-icon [type]="iconTypes.FILTER"></cx-icon>
  {{ 'productList.filterBy.label' | cxTranslate }}
</button>
<app-custom-active-facets></app-custom-active-facets>
@if (isOpen$ | async) {
  <cx-facet-list
    [ngClass]="{ hidden: (facetList$ | async)?.facets.length === 0 }"
    [isDialog]="hasTrigger"
    (closeList)="close()"
    [class.active]="isActive$ | async"
    [class.dialog]="hasTrigger"
  ></cx-facet-list>
}
